import AlertDialog from "@/src/components/atom/AlertDialog";
import { useTranslation } from "react-i18next";

interface CancelBookingAlertDialogProps {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  onOk: () => void;
}

function CancelBookingAlertDialog({
  open,
  onOpenChange,
  onOk,
}: CancelBookingAlertDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog
      open={open}
      title={t("booking:detail.alert.cancelTitle")}
      onOpenChange={onOpenChange}
      onOk={onOk}
      okText={t("booking:detail.button.okButton")}
      cancelText={t("booking:detail.button.cancelButton")}
    >
      {t("booking:detail.alert.cancelDescription")}
    </AlertDialog>
  );
}

export default CancelBookingAlertDialog;
